import {NullableString} from "../../../types/nullable-types";

export enum PsoSeasonIntendedForEnum {
    Workers = "workers",
    Families = "families",
}

export interface IPsoMarketSeasonConfiguration {
    name: string;
    enabled: boolean;
    agent: string;
    bundle: string;
    startDate: NullableString;
    endDate: NullableString;
    intendedFor: PsoSeasonIntendedForEnum;
}

export interface IPsoDiscountConfiguration {
    ssrCode: string;
    feeCode: string;
    percentage: number;
    maxCap: number;
}

export interface IPsoTotalPaxCountOverride {
    paxCount: number;
    advancePurchaseInDays: number;
    organizationCodes: string[];
}

export interface IPsoClassesOfService {
    forResident: string[];
    forWorker: string[];
    forFamily: string[];
}

export interface IPsoMarketConfiguration {
    id: number;
    marketName: string;
    agent: string;
    bookDateStart: string;
    bookDateUntil: string;
    departureDateStart: string;
    departureDateUntil: string;
    allowReducedMobility: boolean;
    allowStudent?: boolean;
    allowMedicalReason?: boolean;
    allowRetired?: boolean;
    useClassesOfService: boolean;
    bundle?: NullableString;
    allowNewBookings: boolean;
    routes: Array<string[]>;
    seasons?: IPsoMarketSeasonConfiguration[];
    discountOptions?: IPsoDiscountConfiguration | null;
    overrideTotalPaxCount?: IPsoTotalPaxCountOverride | null;
}

export interface IPsoMarketsConfiguration {
    markets: IPsoMarketConfiguration[];
    classesOfService: IPsoClassesOfService;
}


